<script>
import Base from '@/plans/ZONE_EDU_PLUS/config/base';

export default {
  extends: Base,
};
</script>
